import forexTradingContent from './content/forex-trading.json';

const forexTradingMock = {
    layoutType: 2,
    data: {
        name: 'what-is-forex-trading',
        layoutType: 2,
        areasList: [
            {
                id: 'forex-trading-page-area',
                name: 'Content',
                componentName: 'Comp:ForexTradingPage',
                content: JSON.stringify(forexTradingContent),
            },
        ],
    },
};

export default forexTradingMock;
